module.exports = __webpack_public_path__ + "img/icon-Preview.dbcf9e84.png";